import { Evidence, Indexed } from "@/types";

export interface Command {
  execute(): [string, any?][];
  undo(): [string, any?][];
}

export class AddCommand implements Command {
  private evidence: Indexed<Evidence>;

  constructor(evidence: Indexed<Evidence>) {
    this.evidence = evidence;
  }

  execute(): [string, any?][] {
    return [["evidences/ADD", this.evidence]];
  }

  undo(): [string, any?][] {
    return [["evidences/REMOVE", this.evidence.index]];
  }
}

export class RemoveCommand implements Command {
  private evidence: Indexed<Evidence>;

  constructor(evidence: Indexed<Evidence>) {
    this.evidence = evidence;
  }

  execute(): [string, any?][] {
    return [["evidences/REMOVE", this.evidence.index]];
  }

  undo(): [string, any?][] {
    return [["evidences/ADD", this.evidence]];
  }
}

export class ReplaceCommand implements Command {
  private index: number;

  private previous: Evidence;

  private next: Evidence;

  constructor(index: number, previous: Evidence, next: Evidence) {
    this.index = index;
    this.previous = previous;
    this.next = next;
  }

  execute(): [string, any?][] {
    return [
      ["evidences/REMOVE", this.index],
      ["evidences/ADD", { index: this.index, value: this.next }]
    ];
  }

  undo(): [string, any?][] {
    return [
      ["evidences/REMOVE", this.index],
      ["evidences/ADD", { index: this.index, value: this.previous }]
    ];
  }
}

export class ReplaceExistingCommand implements Command {
  private previous: Indexed<Evidence>;

  private existing: Indexed<Evidence>;

  constructor(previous: Indexed<Evidence>, existing: Indexed<Evidence>) {
    this.previous = previous;
    this.existing = existing;
  }

  execute(): [string, any?][] {
    return [
      ["evidences/REMOVE", this.existing.index],
      ["evidences/REMOVE", this.previous.index],
      [
        "evidences/ADD",
        {
          index: this.previous.index,
          value: {
            code: this.existing.value.id,
            name: this.existing.value.desc,
            spans: [
              ...new Set([
                ...this.existing.value.spans,
                ...this.previous.value.spans
              ])
            ],
            billable: this.existing.value.billable
          }
        }
      ]
    ];
  }

  undo(): [string, any?][] {
    return [
      ["evidences/REMOVE", this.previous.index],
      ["evidences/ADD", this.previous],
      ["evidences/ADD", this.existing]
    ];
  }
}

export class MutateCommand implements Command {
  private previous: Evidence[];

  private next: Evidence[];

  constructor(previous: Evidence[], next: Evidence[]) {
    this.previous = previous;
    this.next = next;
  }

  execute(): [string, any?][] {
    return [["evidences/UPDATE", this.next]];
  }

  undo(): [string, any?][] {
    return [["evidences/UPDATE", this.previous]];
  }
}
